import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const BASE_URL = API_BASE_URL;

/**
 *
 * @param {*} params
 * @returns {Promise<FetchRegionListResponse>}
 */
export function requestSmartSuiteAgreement(params) {
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/smart-proposal/smartsuiteagreement`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  } else {
    return fetch.get(`${BASE_URL}/api/app/smart-proposal/smartsuiteagreement?${params}`, {
      // params: { limit: Number.MAX_SAFE_INTEGER },
    });
  }
}
export function requestLienList (){
  return fetch.get(`${BASE_URL}/api/app/lender-master`)
}
export function fetchBrokerDetailsById(params) {
   let paramsOne=params?.queryKey[0]
  if (params === undefined) {
    return;
  } else {
    return fetch.get(`${BASE_URL}/api/app/agreement/brokerDetail/${paramsOne}`, {
    });
  }
}

export function requestSmartSuiteAgreementLog(params) {
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/auditLog/getData?${params}`, {
    });
  } else {
    return fetch.get(`${BASE_URL}/api/app/auditLog/getData?${params}`, {
    });
  }
}
// export function requestSmartSuiteAgreementLog(params) {
//   if (params === undefined) {
//     return fetch.get(`${BASE_URL}/api/app/auditLog/getData?moduleName=agreement&agreementId=64ad206f8541d5489d837dcb`, {
//       // params: { limit: Number.MAX_SAFE_INTEGER },
//     });
//   } else {
//     return fetch.get(`${BASE_URL}/api/app/auditLog/getData?moduleName=agreement&agreementId=${params.agreementId}`, {
//       // params: { limit: Number.MAX_SAFE_INTEGER },
//     });
//   }
// }

/**
 * smart suite agreement
 * @param { CreateSmartSuiteAgreement } data
 */
export function requestCreateSmartSuiteAgreement(value) {
  console.log('requestCreateSmartSuiteAgreement', value)
  return fetch.post(`${BASE_URL}/api/app/smart-proposal/smartsuiteagreement`, {
    ...value,
  });
}

/**
 *
 * @param { UpdateSmartSuiteAgreement } data
 */
export function requestUpdateSmartSuiteAgreement(value) {
  const data = { ...value };
  delete data["_id"];
  return fetch.put(
    `${BASE_URL}/api/app/agreement/updateAgreement/${value.agreementId}`,
    {
      ...data,
    }
  );
}
export function requestVerifySmartSuiteAgreement(value){
  const data = {...value, sendToMSD: true};
   delete data["agreementId"];
   let newData = data;
    if(value.linkedAgreement){
      newData.agreementId =value.linkedAgreement
    }
   delete newData["linkedAgreement"];
return fetch.put(
  `${BASE_URL}/api/app/agreement/verifyAgreement/${value.agreementId}`,
    {...newData},
  
)
}

export function fetchEntityNames(){
  return fetch.get(`${BASE_URL}/api/app/agreement/getEntityNames`)
}

export function fetchAgreementsByEntity(entityName){
  return fetch.get(
    `${BASE_URL}/api/app/agreement/getAgreementsByEntity?entityName=${encodeURIComponent(entityName)}`
  )
}

export function fetchClientAgreementList(clientId){
  return fetch.get(
    `${BASE_URL}/api/app/agreement/getClientAgreements/${clientId}`
  )
}

export function requestSendMoveInEmail(value){
  const data= {...value};
  return fetch.post(`${BASE_URL}/api/app/agreement/sendMoveInMail`,
  {...data},
  )
}
export function fetchBrokerAgreementDetails(value){
  if(!value){
    return fetch.get(`${BASE_URL}/api/app/agreement/fetchBrokerAgreementDetails`,)
  }else{
    return fetch.get(`${BASE_URL}/api/app/agreement/fetchBrokerAgreementDetails?${value}`,
    )
  }
}
export function creatBrokerageDetail(value){
  const data= {...value};
  return fetch.post(`${BASE_URL}/api/app/agreement/brokeragedetail`,
  {...data},
  )
}
export function updateBrokerageDetail(value){
  const data= {...value};
  return fetch.put(`${BASE_URL}/api/app/agreement/brokeragedetail/${value._id}`,
  {...data},
  )
}

/**
 *
 * @param { AgreementKycDocuments } data
 */
export function requestUpdateAgreementKycDocuments(value) {
  const data = { ...value };
  delete data["_id"];
  return fetch.put(
    `${BASE_URL}/api/app/smart-proposal/smartsuiteagreement/${value._id}`,
    {
      ...data,
    }
  );
}

/**
 *
 * @param { AgreementSignedDocument } data
 */
export function requestUpdateAgreementSignedDocument(value) {
  const data = { ...value };
  delete data["_id"];
  return fetch.put(
    `${BASE_URL}/api/app/smart-proposal/smartsuiteagreement/${value._id}`,
    {
      ...data,
    }
  );
}

/**
 * smart suite agreement
 * @param { DeleteSmartSuiteAgreement } data
 */
export function requestDeleteSmartSuiteAgreement(data) {
  // const body = { ...data }
  // delete body["_id"];
  return fetch.delete(`${BASE_URL}/api/app/smart-proposal/smartsuiteagreement/${data}`);
}

/**
 *
 * @param { ExpansionSmartSuiteAgreement } data
 */
export function requestExpansionSmartSuiteAgreement(value) {
  const data = { ...value };
  // delete data["_id"];
  return fetch.put(
    `${BASE_URL}/api/app/agreement/expansion`,
    {
      ...data,
    }
  );
}

/**
 *
 * @param {*} params
 * @returns {Promise<FetchRegionListResponse>}
 */
export function requestAgrExpansionDetails(data) {
  if (data !== undefined) {
    return fetch.get(`${BASE_URL}/api/app/agreement/getExpansionList?agreementId=${data?.agreementId}&endDate=${data?.endDate}&startDate=${data?.startDate}`);
  }
}

/**
 *
 * @param {*} params
 * @returns {Promise<FetchRegionListResponse>}
 */
export function requestAgreementById(data) {
  if (data.id) {
    return fetch.get(`${BASE_URL}/api/app/smart-proposal/smartsuiteagreement/getById/${data.id}`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  }
}

// export function requestClientTicketsData(data) {
//   if (data !== undefined) {
//     return fetch.get(`${BASE_URL}/api/app/sync-olderp/getzohotickets`, {
//       params: { limit: Number.MAX_SAFE_INTEGER },
//     });
//   }
// }


/**
 * Renewal smart suite agreement
 * @param { CreateSmartSuiteAgreement - Renewal } data
 */
export function requestRenewalCreateSmartSuiteAgreement(value) {
  return fetch.post(`${BASE_URL}/api/app/agreement`, {    //Renewalsmartsuiteagreement
    ...value,
  });
}

export function requestClientTicketsData(value) {
  return fetch.post(`https://erp.sworks.co.in/api//api/app/sync-olderp/getzohotickets`, {
    ...value,
  });
}

/**
 *
 * @param { AgreementKycDocuments } data
 */
export function requestUpdateAgreementDocuments(value) {
  const data = { ...value };
  delete data["_id"];
  return fetch.put(
    `${BASE_URL}/api/app/agreement/updateExpansionDoc/${value._id}`,
    {
      ...data,
    }
  );
}

export function requestSmartSuiteAgreementDocument(params) {
  if (params === undefined) {
    return fetch.get(`${BASE_URL}/api/app/agreement/uploadSignedDoc`, {
      params: { limit: Number.MAX_SAFE_INTEGER },
    });
  } else {
    return fetch.get(
      `${BASE_URL}/api/app/agreement/uploadSignedDoc?${params}`,
      {
        params: { limit: Number.MAX_SAFE_INTEGER },
      }
    );
  }
}

export function requestLinkAgreementAccount(value) {
  const data = { ...value };
  delete data["_id"];
  return fetch.put(
    `${BASE_URL}/api/app/account/linkAgreement/${value.agreementId}`,
    {
      ...data,
    }
  );
}
// export function requestMsdToken(value) {
//   return fetch.get(
//     `${BASE_URL}/api/app/account/generateMSDToken`,
//   );
// }

export function requestMsdToken(value){
  if(!value){
    return fetch.get(`${BASE_URL}/api/app/account/generateMSDToken`,)
  }else{
    return fetch.get(`${BASE_URL}/api/app/account/generateMSDToken`,
    )
  }
}